import * as React from "react";

function SvgSalesFilled(props) {
  return <svg viewBox="0 0 40 40" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M21.358.25L1.388 20.22a4.166 4.166 0 000 5.893l12.5 12.5a4.166 4.166 0 005.891 0l19.97-19.971V.25H21.36zm11.1 10.417a3.126 3.126 0 010-6.25 3.126 3.126 0 010 6.25z" /></svg>;
}

export default SvgSalesFilled;